/* eslint-disable react-hooks/exhaustive-deps */
import './App.scss';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import { connect } from 'react-redux';
import Routes from './Routes';
import { history } from './store/index'
import { RootState } from './store/index';
import { authSlice } from './store/reducer/auth';
import { useEffect } from 'react';
import { userSlice } from './store/reducer/user';
import { stateSlice } from './store/reducer/state';
import { debounce } from 'lodash';
import { Action } from 'history';

const theme = createTheme({
  typography: {
    fontFamily: ['"Source Sans Pro"', 'sans-serif'].join(','),
  },
});

const App = ({ dispatch, isAuthenticated, hasAddress }: any) => {

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(authSlice.actions.signinSuccess());
      dispatch(stateSlice.actions.fetchState());
      dispatch(userSlice.actions.fetchUser());
    }
  }, []);
  
  const debouncedStateUpdate = debounce(() => {
    dispatch(stateSlice.actions.updatePersistedState());
    dispatch(stateSlice.actions.fetchFilingDate());
  }, 800);

  useEffect(() => history.listen((update) => {
    if (isAuthenticated) {
      debouncedStateUpdate();
    }
  }), [isAuthenticated]);

  /*useEffect(() => store.subscribe(
    // we use debounce to save the state once each 800ms
    // for better performance in case multiple changes occur in a short time
    debounce(() => {
      saveStateToLocalStorage(window.location.pathname, store.getState());
    }, 800)
  ), []);*/

  return (
    <div className="App">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes isLoggedIn={isAuthenticated} />
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
};


const mapStateToProps = (state : RootState) => {
  return { 
    isAuthenticated: state.auth.isAuthenticated,
  }
}

export default connect(mapStateToProps)(App);
